import { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";

import api from '../../lib/api';
import { toast } from '../ui/use-toast';

const ChangePrizeDialog = ({ registration, fetchQualifications }) => {

    const [isLoading, setIsLoading] = useState(false);
    const bunny = registration.bunny;
    const prize = registration.award.prize;



    const { behaviour } = prize === false
        ? { behaviour: 'give' }
        : { behaviour: 'remove' };

    const handleChange = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await api.post(`https://skhrf-api.cmdigital.se/v1/registrations/${behaviour}-prize`, {
                registrationId: registration.registrationId,
            });
            toast({
                title: 'Utmärkelse ändrad',
                description: prize ? `${bunny.name} fick pris borttaget` : `${bunny.name} fick pris`,
            });
            fetchQualifications();
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog>
            <DropdownMenuItem
                className={`text-${prize ? 'destructive' : 'default'} w-full`}
                onSelect={(event) => event.preventDefault()}>
                <DialogTrigger variant={prize ? 'destructive': ''} className='flex items-center w-full'>
                    {prize ? 'Ta bort pris' : 'Tilldela pris'}
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Ändra prisstatus för {bunny.name}
                    </DialogTitle>
                    <DialogDescription>
                        {prize ? `Är du helt säker på att du vill ta bort pris från ${bunny.name}?` : `Är du helt säker på att du vill ge ${bunny.name} ett pris?`}
                    </DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button variant={prize ? 'destructive': ''} onClick={handleChange} disabled={isLoading}>
                        {prize ? 'Ta bort pris' : 'Tilldela pris'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ChangePrizeDialog;
